// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__15g8a","col":"styles_col__1GX8C","fulfillmentStatus":"styles_fulfillmentStatus__icyue","emailCol":"styles_emailCol__Xcs6j"};